export const menuData = [
    { title: <>Рішення для фізичних та < br /> юридичних осіб</> },
    { title: 'Індивідуальні рішення' },
    { title: 'Контакти' },
]
